"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputsWithNames = getInputsWithNames;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));
function getInputsWithNames(inputsMap, inputNames = []) {
  const filteredInputs = new _map.default();
  (0, _forEach.default)(inputsMap).call(inputsMap, (inputState, inputElement) => {
    if ((0, _includes.default)(inputNames).call(inputNames, inputElement.name)) {
      filteredInputs.set(inputElement, inputState);
    }
  });
  return filteredInputs;
}